<template>
  <div v-if="resultEvaluation" class="resultado_avaliacao">
    <!--Stats cards-->
    <h4 class="title" style="margin-bottom: 25px;"> {{ resultEvaluation.evaluation_cycle_name }} - {{
      resultEvaluation.evaluation_type_name }} <small>{{ resultEvaluation.evaluation_cycle_start_date | formatDateBr }}
        - {{ resultEvaluation.evaluation_cycle_end_date | formatDateBr }}</small></h4>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-content desc_member">
            <div class="row">
              <div class="col-md-2 col-xs-4">
                <div class="avatar img_member"><img :src="resultEvaluation.collaborator.avatar_url" alt="Circle Image"
                    class="img-circle img-no-padding img-responsive"></div>
              </div>
              <div class="col-md-10 col-xs-8">
                <div class="pull-left name_member">
                  <span>
                    {{ resultEvaluation.collaborator.name }}
                  </span><br /><small>{{ resultEvaluation.collaborator.position.name }}</small> <br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <circle-chart-card :percentage="resultEvaluation.final_result" title="RESULTADO FINAL"
          :description="resultEvaluation.evaluation_type_name"
          :color="percentTotalColor(resultEvaluation.final_result)">
        </circle-chart-card>
      </div>
      <div class="col-lg-6 col-sm-6" v-if="!resultEvaluation.blocked">
        <circle-chart-card :percentage="resultEvaluation.total_skill_percent" title="COMPETÊNCIAS"
          :color="percentTotalColor(resultEvaluation.total_skill_percent)">
        </circle-chart-card>
      </div>
      <div class="col-lg-6 col-sm-6" v-if="!resultEvaluation.blocked">
        <circle-chart-card :percentage="resultEvaluation.delivery_percent" title="ENTREGA"
          :color="percentTotalColor(resultEvaluation.delivery_percent)">
        </circle-chart-card>
      </div>
    </div>
    <div class="row" v-if="!resultEvaluation.blocked">
      <div class="col-lg-12 col-sm-12">
        <stats-card>
          <div class="icon-big text-center" slot="header">
            <i class="ti-package"></i>
          </div>
          <div class="numbers" slot="content">
            <p class="category">COMPETÊNCIAS</p>
          </div>
          <div class="stats" slot="footer">
            <div v-for="(skill, index) in resultEvaluation.skills" :key="`skill-${index}`">
              <div class="row">
                <div class="col-xs-10 comp">
                  {{ skill.name }}
                </div>
                <div class="col-xs-2 grade_comp">
                  {{ skill.percent }}%
                </div>
              </div>
              <p-progress :value="skill.percent" :type="percentColor(skill.percent)"></p-progress>
            </div>
          </div>
        </stats-card>
      </div>
    </div>

    <info-pdi-9box :resultEvaluation="resultEvaluation" v-if="!resultEvaluation.blocked && resultEvaluation.evaluation_type_id == 1"></info-pdi-9box>

    <div class="row" v-if="resultEvaluation.evaluation_type_id == 1">
      <div class="col-lg-12 col-md-12">
        <div class="card card-plano-acao">
          <div class="card-header">
            <h4 class="card-title">PLANO DE AÇÃO</h4>
            <p class="category">Plano de Desenvolvimento proposto por seu Gestor Imediato para a competência
              selecionada.</p>
          </div>
          <div class="card-content">
            <div class="row">
              <!-- START INDEX -->
              <div class="col-lg-12 col-md-12" v-if="steps.index">
                <el-collapse v-if="resultEvaluation.plan">
                  <el-collapse-item :title="`${resultEvaluation.plan.development_plan_name} | ${translateStatus(resultEvaluation.plan.status)}`" name="1">
                    <div style="padding-top: 20px;">
                      <i class="ti-calendar"></i>&nbsp;&nbsp;<b>Data de Início:</b> {{ resultEvaluation.plan.start_date
                      | formatDateBr }}<br />
                      <i class="ti-calendar"></i>&nbsp;&nbsp;<b>Data de Término:</b> {{ resultEvaluation.plan.end_date |
                      formatDateBr }}<br /><br />

                      <div>
                        <i class="ti-ticket"></i>&nbsp;&nbsp;<b>Competência:</b> <br />
                        <span v-for=" skill in resultEvaluation.plan.newSkills" style="font-size: 14px;">
                          <u>{{ skill.skill && skill.skill.name ? skill.skill.name : skill.name }}</u><br />
                          {{ skill.skill && skill.skill.description ? skill.skill.description : skill.description
                          }}<br /><br />
                        </span>
                        <br />
                      </div>

                      <div v-if="resultEvaluation.plan.description">
                        <i class="ti-clipboard"></i>&nbsp;&nbsp;<b>Descrição:</b><br />
                        <div style="text-align: justify;"> {{ resultEvaluation.plan.description }} </div><br />
                      </div>

                      <div v-if="resultEvaluation.plan.action_plan_objective">
                        <i class="ti-star"></i>&nbsp;&nbsp;<b>Objetivo:</b><br />
                        <div style="text-align: justify;"> {{ resultEvaluation.plan.action_plan_objective }} </div>
                        <br />
                      </div>

                      <div v-if="resultEvaluation.plan.identified_improvement_areas">
                        <i class="ti-bookmark"></i>&nbsp;&nbsp;<b>Áreas de Melhoria:</b><br />
                        <div style="text-align: justify;"> {{ resultEvaluation.plan.identified_improvement_areas }}
                        </div><br />
                      </div>

                      <div v-if="resultEvaluation.plan.action_plan_goals_old">
                        <i class="ti-check-box"></i>&nbsp;&nbsp;<b>Metas:</b><br />
                        <div style="text-align: justify;"> {{ resultEvaluation.plan.action_plan_goals_old }} </div><br />
                      </div>

                      <div v-else-if="resultEvaluation.plan.action_plan_goals.length != 0">
                        <i class="ti-check-box"></i>&nbsp;&nbsp;<b>Metas:</b><br/>

                        <div 
                          v-for="(goal, index) in resultEvaluation.plan.action_plan_goals" 
                          :key="goal.id" 
                          class="goal"
                          style="margin-top: 10px; margin-bottom: 15px;"
                        >
                          <!-- <div class="panel-heading">
                            <h6>Meta {{ index + 1 }}</h6>
                          </div> -->
                          <div class="goal-title">
                            <span class="dot">•</span>
                            <b>Meta {{ index + 1 }}</b>
                            <span>-</span>
                            <span>{{ translateStatus(goal.status) }}</span>
                            <span>-</span>
                            <span>{{ goal.progress }}%</span>
                          </div>

                          <div class="goal-body">
                            <!-- Barra de progresso -->
                            <div class="progress" style="margin-bottom: 10px; height: 5px;">
                              <div 
                                class="progress-bar" 
                                role="progressbar"
                                :aria-valuenow="goal.progress"
                                aria-valuemin="0" 
                                aria-valuemax="100"
                                :style="'width: ' + goal.progress + '%;'"
                              >
                                <!-- {{ goal.progress }}% -->
                              </div>
                            </div>

                            <b>Descrição:</b> {{ goal.goal }}</br>
                            <b>Estratégia:</b> {{ goal.strategy }}</br>
                            <b>Prazo:</b> {{ formatDate(goal.due_date) }}
                            <!-- <p v-if="goal.due_date">
                            </p> -->
                          </div>
                        </div>
                      </div>

                      <div v-if="resultEvaluation.plan.strategies_to_reach_goals_old">
                        <i class="ti-list"></i>&nbsp;&nbsp;<b>Estratégias para Alcançar as Metas:</b><br />
                        <div style="text-align: justify;"> {{ resultEvaluation.plan.strategies_to_reach_goals_old }} </div>
                        <br />
                      </div>

                      <div v-if="resultEvaluation.plan.success_indicators && resultEvaluation.plan.success_indicators.length > 0">
                        <i class="ti-stats-up"></i>&nbsp;&nbsp;<b>Indicadores de Sucesso:</b><br />
                        <div v-for=" successIndicator in resultEvaluation.plan.success_indicators">
                          <div style="text-align: justify;"> - {{ successIndicator.success_indicator.description }}
                          </div>
                        </div><br />
                      </div>

                      <div v-if="resultEvaluation.plan.monitoring_meetings && resultEvaluation.plan.monitoring_meetings.length > 0">
                        <i class="ti-timer"></i>&nbsp;&nbsp;<b>Acompanhamento:</b><br/>
                        <div style="text-align: justify;">
                          Próxima reunião: {{ formatNextMonitoring(resultEvaluation.plan.next_monitoring, steps) }}
                        </div><br />
                        
                        <i class="ti-agenda"></i>&nbsp;&nbsp;<b>Histórico de Reuniões:</b><br/>
                        <div v-if="pastMeetings.length && pastMeetings.length > 0" class="carousel-wrapper">
                          <!-- Botão anterior -->
                          <button class="nav-button left" @click="prevMeeting" :disabled="currentMeetingIndex === 0"><i class="ti-angle-left"></i></button>

                          <!-- Card da reunião com transição -->
                          <transition :name="slideDirection" mode="out-in">
                            <div class="carousel-card" :key="currentPastMeeting.id">
                              <b>Data:</b> {{ formatDate(currentPastMeeting.date) }}<br>
                              <div v-if="currentPastMeeting.status === 2">
                                <span>Reunião não realizada.</span>
                              </div>
                              <div v-else>
                                <div v-for="goalProgress in currentPastMeeting.goal_progresses">
                                  <div v-if="goalProgress.progress_change > 0">
                                    <i class="ti-arrow-up"></i>
                                    <b>
                                      <span v-if="goalProgress.action_plan_goal.deleted_at">Meta (excluída):</span>
                                      <span v-else>Meta:</span>
                                    </b>
                                    <span style="color: green;"> + {{ goalProgress.progress_change }}%</span>
                                    <span>{{ goalProgress.action_plan_goal.goal }}</span>
                                  </div>
                                  <div v-else-if="goalProgress.progress_change == 0">
                                    <b>
                                      <span v-if="goalProgress.action_plan_goal.deleted_at">Meta (excluída):</span>
                                      <span v-else>Meta:</span>
                                    </b>
                                    <span> + {{ goalProgress.progress_change }}%</span>
                                    <span>{{ goalProgress.action_plan_goal.goal }}</span>
                                  </div>
                                  <div v-else>
                                    <i class="ti-arrow-down"></i>
                                    <b>
                                      <span v-if="goalProgress.action_plan_goal.deleted_at">Meta (excluída):</span>
                                      <span v-else>Meta:</span>
                                    </b>
                                    <span style="color: red;"> - {{ goalProgress.progress_change * (-1) }}%</span>
                                    <span>{{ goalProgress.action_plan_goal.goal }}</span>
                                  </div>
                                </div>
                                <b>Feedbacks:</b> {{ currentPastMeeting.feedbacks }}<br>
                              </div>
                            </div>
                          </transition>

                          <!-- Botão próximo -->
                          <button class="nav-button right" @click="nextMeeting" :disabled="currentMeetingIndex >= pastMeetings.length - 1"><i class="ti-angle-right"></i></button>
                          <div class="carousel-indicators">
                            <span
                              v-for="(meeting, index) in pastMeetings"
                              :key="meeting.id"
                              :class="['indicator-dot', { active: index === currentMeetingIndex }]"
                              @click="goToMeeting(index)"
                            ></span>
                          </div>
                        </div>
                        <div v-else style="text-align: justify;">
                          As reuniões de acompanhamento realizadas aparecerão aqui.
                        </div><br /><br />
                        
                      </div>

                      <!-- LEGADO -->
                      <div v-else-if="resultEvaluation.plan.monitoring_frequencies.length > 0">
                        <i class="ti-timer"></i>&nbsp;&nbsp;<b>Frequência de Monitoramento:</b><br />
                        <div v-for=" monitoringFrequency in resultEvaluation.plan.monitoring_frequencies">
                          <div style="text-align: justify;"> - {{ monitoringFrequency.monitoring_frequency.description
                            }} </div>
                        </div><br />
                      </div>
                      <!-- LEGADO -->

                    </div>
                  </el-collapse-item>
                </el-collapse>
                <div style="margin:20px 0;" v-if="resultEvaluation.evaluation_cycle_active">
                  <button type="button" @click="handleEdit(resultEvaluation.plan)" class="btn btn-wd btn-warning">
                    <span class="btn-label"><i class="ti-pencil-alt"></i></span>
                    Editar
                  </button>
                  <button type="button" @click="handleMonitoring(resultEvaluation.plan)" class="btn btn-wd btn-warning" style="margin-left: 5px;" :disabled="!checkMonitoringByToday(resultEvaluation.plan.next_monitoring)">
                    <span class="btn-label"><i class="ti-timer"></i></span>
                    {{ resultEvaluation.plan.next_monitoring ? (
                      checkMonitoringByToday(resultEvaluation.plan.next_monitoring) ? 'Iniciar Acompanhamento' : `Próximo Acompanhamento: ${formatDate(resultEvaluation.plan.next_monitoring.date)}`
                    ) : 'Sem Acompanhamento Agendado' }}
                  </button>
                </div>
              </div>
              <!-- END INDEX -->

              <!-- START UPDATE -->
              <div class="col-lg-12 col-md-12" v-if="steps.update">
                <!-- <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="control-label">Plano de Desenvolvimento*</label>
                      <div>
                        <el-select class="select-default" size="large" placeholder="Selecione..." v-model="developmentPlan.development_plan_id" @change="developmentPlanShow()">
                          <el-option v-for="developmentPlan in developmentPlans" class="select-default"
                                          :value="developmentPlan.id"
                                          :label="developmentPlan.name"
                                          :disabled="!checkAccessUser(developmentPlan.id)"
                                          :key="developmentPlan.id">
                          </el-option>
                        </el-select>
                      </div>
                    </div>                
                  </div>
                </div> -->
                <div class="row" v-if="!!developmentPlanSelected.description">
                  <div class="col-md-12" style="margin-bottom:13px;">
                    <blockquote style="font-style: normal; font-size: 14px;">
                      {{ developmentPlanSelected.description }}
                    </blockquote>
                  </div>
                </div>
                <div class="row" style="margin-top:13px;">
                  <div class="col-md-12" style="margin-bottom:13px;">
                    Caro(a) Gestor(a), favor levar em consideração abaixo o tempo necessário para o colaborador
                    desenvolver a competência. Tempo mínimo do Plano de Ação: 20 dias.
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="control-label">Data de Início*</label>
                      <div>
                        <el-date-picker v-model="developmentPlan.start_date" format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd" type="date" placeholder="Selecione a data"
                          :picker-options="pickerOptionsStart" :disabled="atLeastOneMeetingHeld" @change="clearAllDates">
                        </el-date-picker>
                      </div>
                      <div v-if="atLeastOneMeetingHeld" style="margin-top: 10px; font-size: 12px; color: gray;">
                        <span>Não é possível alterar a data de início pois existem reuniões de acompanhamento já realizadas.</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="control-label">Data de Término*</label>
                      <div>
                        <el-date-picker v-model="developmentPlan.end_date" format="dd/MM/yyyy" value-format="yyyy-MM-dd"
                          type="date" placeholder="Selecione a data" :picker-options="pickerOptionsEnd" @change="clearAllDates">
                        </el-date-picker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div v-if="resultEvaluation.plan.description" class="form-group">
                      <label class="control-label">Descrição*</label>
                      <textarea class="form-control" placeholder="Descreva as atividades a serem executadas." rows="3"
                        v-model="developmentPlan.description" maxlength="2000"></textarea>
                    </div>
                    <div class="form-group">
                      <label class="control-label">Objetivo*</label>
                      <textarea class="form-control" placeholder="Descreva os objetivos do plano de ação." rows="3"
                        v-model="developmentPlan.action_plan_objective" maxlength="2000"></textarea>
                    </div>
                    <div class="form-group">
                      <label class="control-label">Áreas de Melhoria*</label>
                      <textarea class="form-control" placeholder="Informe onde o colaborador pode melhorar." rows="3"
                        v-model="developmentPlan.identified_improvement_areas" maxlength="2000"></textarea>
                    </div>
                    <div v-if="resultEvaluation.plan.action_plan_goals_old" class="form-group">
                      <label class="control-label">Metas*</label>
                      <textarea class="form-control" placeholder="Descreva as metas do plano de ação." rows="3"
                        v-model="developmentPlan.action_plan_goals_old" maxlength="2000"></textarea>
                    </div>
                    <div v-else-if="resultEvaluation.plan.action_plan_goals.length != 0" class="form-group">
                      <label class="control-label">
                        Metas*
                      </label>

                      <!-- Lista de metas -->
                      <div v-for="(goalItem, index) in developmentPlan.action_plan_goals" :key="index" class="well" style="padding: 15px; margin-bottom: 10px;">
                        <div class="form-group">
                          <label>Meta {{ index + 1 }}*</label>
                          <input type="text"
                                class="form-control"
                                v-model="goalItem.goal"
                                :placeholder="'Digite a meta ' + (index + 1)"
                                maxlength="200">
                        </div>

                        <div class="form-group">
                          <label class="control-label">Prazo*</label>
                          <div>
                            <el-date-picker 
                              v-model="goalItem.due_date" 
                              format="dd/MM/yyyy" 
                              value-format="yyyy-MM-dd"
                              type="date" 
                              placeholder="Selecione a data" 
                              :disabled="!developmentPlan.start_date || !developmentPlan.end_date"
                              :picker-options="pickerOptionsGoals"
                              >
                            </el-date-picker>
                          </div>
                        </div>

                        <div class="form-group">
                          <label>Estratégias para alcançar essa meta*</label>
                          <textarea class="form-control"
                                    v-model="goalItem.strategy"
                                    placeholder="Ex.: Participação em cursos, feedbacks periódicos, envolvimento em projetos..."
                                    rows="3"
                                    maxlength="2000"></textarea>
                        </div>

                        <button class="btn btn-danger btn-sm"
                                type="button"
                                @click="removeGoal(index)"
                                :disabled="developmentPlan.action_plan_goals.length === 1">
                          <i class="fa fa-trash"></i> Remover
                        </button>
                      </div>

                      <!-- Botão de adicionar -->
                      <button class="btn btn-info btn-sm" type="button" @click="addGoal">
                        <i class="fa fa-plus"></i> Adicionar Meta
                      </button>
                    </div>
                    <div v-if="resultEvaluation.plan.strategies_to_reach_goals_old" class="form-group">
                      <label class="control-label">Estratégias para Alcançar as Metas*</label>
                      <textarea class="form-control" placeholder="Sugira estratégias para alcançar as metas." rows="3"
                        v-model="developmentPlan.strategies_to_reach_goals_old" maxlength="2000"></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="control-label">Indicadores de Sucesso*</label>
                      <div v-for="(indicator, index) in successIndicators" :key="index">
                        <input type="checkbox" :id="'success-indicator-checkbox-' + index" :value="indicator.id"
                          v-model="developmentPlan.success_indicators" />
                        <label :for="'success-indicator-checkbox-' + index" class="non-bold-label">{{
                          indicator.description }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-md-12">
                    <div class="form-gorup">
                      <label class="control-label">Frequência de Monitoramento*</label>
                      <div v-for="(frequency, index) in monitoringFrequency" :key="index">
                        <input type="checkbox" :id="'monitoring-frequency-checkbox-' + index" :value="frequency.id"
                          v-model="developmentPlan.monitoring_frequencies" />
                        <label :for="'monitoring-frequency-checkbox-' + index" class="non-bold-label">{{
                          frequency.description }}</label>
                      </div>
                    </div>
                  </div>
                </div> -->
                
                <div class="row">
                  <div class="col-md-12" style="margin-bottom:13px;"><br />
                    As reuniões periódicas de acompanhamento devem ter um intervalo de no mínimo 15 dias da data de início ou da última reunião.
                  </div>
                  <div class="col-md-12">
                    <div class="form-gorup">
                      <label class="control-label">Reuniões de Acompanhameto*</label>
                      <div v-for="(meeting, index) in developmentPlan.monitoring_meetings" :key="index" class="input-group" style="margin-bottom: 10px;">
                        <el-date-picker
                          v-model="developmentPlan.monitoring_meetings[index].date"
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="Selecione a data"
                          :disabled="!developmentPlan.start_date || !developmentPlan.end_date || meeting.status == 1 || meeting.status == 2"
                          :picker-options="getMeetingDatePickerOptions(index, steps)">
                        </el-date-picker>
                        <span class="input-group-btn">
                          <button class="btn btn-danger btn-sm"
                                  type="button"
                                  @click="removeMeetingDate(index, steps)"
                                  :disabled="developmentPlan.monitoring_meetings.length === 1 || meeting.status == 1 || meeting.status == 2">
                            <i class="fa fa-trash"></i>
                          </button>
                        </span>
                      </div>
                      <!-- Botão de adicionar nova data manual -->
                      <button class="btn btn-info btn-sm" type="button" @click="addMeetingDate(steps)" :disabled="!canAddNewMeetingDate">
                        <i class="fa fa-plus"></i> Adicionar Data
                      </button>
                      <span v-if="noMeetingDateAvailable" style="font-size: 12px; color: gray; margin-left: 10px;">Não é possível adicionar mais reuniões dentro do intervalo atual.</span>
                    </div>
                  </div>
                </div>
                <div style="margin:20px 0;">
                  <button type="button" @click="validDevelopmentPlan()" class="btn btn-wd btn-success">
                    <loading-spin :check="loading" class="loading-spin-login"></loading-spin>
                    Salvar
                  </button>
                  <button type="button" @click="handleCancelEditing()" class="btn btn-wd btn-danger">
                    Cancelar
                  </button>
                </div>
              </div>
              <!-- END UPDATE -->

              <!-- START MONITORING -->
              <div class="col-lg-12 col-md-12" v-if="steps.monitoring">
                <div class="row">
                  <div class="col-md-12">
                    <i class="ti-check-box"></i>&nbsp;&nbsp;<b>Metas:</b><br/>

                    <div 
                      v-for="(goal, index) in monitoringGoals" 
                      :key="goal.id" 
                      class="goal"
                      style="margin-top: 10px; margin-bottom: 15px;"
                    >

                      <div class="goal-title">
                        <span class="dot">•</span>
                        <b>Meta {{ index + 1 }}</b>
                        <span>-</span>
                        <span>{{ goal.progress }}%</span>
                      </div>

                      <div class="goal-body">
                        <!-- Slider de progresso -->
                        <div style="margin-bottom: 10px;">
                          <el-slider
                            v-model="goal.progress"
                            :min="0"
                            :max="100"
                            :step="5"
                            show-tooltip
                            :format-tooltip="formatTooltip"
                          ></el-slider>
                        </div>

                        <b>Descrição:</b> {{ goal.goal }}<br/>
                        <b>Estratégia:</b> {{ goal.strategy }}<br/>
                        <b>Prazo:</b> {{ formatDate(goal.due_date) }}
                      </div>

                    </div>
                  </div>
                </div>

                <div class="row" style="margin-top: 20px;">
                  <div class="col-md-12">
                    <label><i class="ti-comment-alt"></i>&nbsp;&nbsp;<b>Feedbacks do acompanhamento:</b></label>
                    <textarea 
                      class="form-control" 
                      rows="4" 
                      placeholder="Escreva aqui as observações ou feedbacks desta reunião..."
                      v-model="monitoring.feedbacks"
                    ></textarea>
                  </div>
                </div>

                <div v-if="pastMeetings && pastMeetings.length > 0" style="margin-top: 20px;">
                  <i class="ti-agenda"></i>&nbsp;&nbsp;<b>Histórico de Reuniões:</b><br/>

                  <div class="carousel-wrapper">
                    <!-- Botão anterior -->
                    <button class="nav-button left" @click="prevMeeting" :disabled="currentMeetingIndex === 0"><i class="ti-angle-left"></i></button>

                    <!-- Card da reunião com transição -->
                    <transition :name="slideDirection" mode="out-in">
                      <div class="carousel-card" :key="currentPastMeeting.id">
                        <b>Data:</b> {{ formatDate(currentPastMeeting.date) }}<br>
                        <div v-for="(goalProgress, index) in currentPastMeeting.goal_progresses">
                          <div v-if="goalProgress.progress_change && goalProgress.progress_change > 0">
                            <i class="ti-arrow-up"></i>
                            <b>
                              <span v-if="goalProgress.action_plan_goal.deleted_at">Meta (excluída):</span>
                              <span v-else>Meta:</span>
                            </b>
                            <span style="color: green;"> + {{ goalProgress.progress_change }}%</span>
                            <span>{{ goalProgress.action_plan_goal.goal }}</span>
                          </div>
                          <div v-else-if="goalProgress.progress_change == 0">
                            <b>
                              <span v-if="goalProgress.action_plan_goal.deleted_at">Meta (excluída):</span>
                              <span v-else>Meta:</span>
                            </b>
                            <span> + {{ goalProgress.progress_change }}%</span>
                            <span>{{ goalProgress.action_plan_goal.goal }}</span>
                          </div>
                          <div v-else>
                            <i class="ti-arrow-down"></i>
                            <b>
                              <span v-if="goalProgress.action_plan_goal.deleted_at">Meta (excluída):</span>
                              <span v-else>Meta:</span>
                            </b>
                            <span style="color: red;"> - {{ goalProgress.progress_change * (-1) }}%</span>
                            <span>{{ goalProgress.action_plan_goal.goal }}</span>
                          </div>
                        </div>
                        <b>Feedbacks:</b> {{ currentPastMeeting.feedbacks }}<br>
                      </div>
                    </transition>

                    <!-- Botão próximo -->
                    <button class="nav-button right" @click="nextMeeting" :disabled="currentMeetingIndex >= pastMeetings.length - 1"><i class="ti-angle-right"></i></button>
                    <div class="carousel-indicators">
                      <span
                        v-for="(meeting, index) in pastMeetings"
                        :key="meeting.id"
                        :class="['indicator-dot', { active: index === currentMeetingIndex }]"
                        @click="goToMeeting(index)"
                      ></span>
                    </div>
                  </div><br />
                </div>

                <div class="row" style="margin-top: 20px;">
                  <div class="col-md-12">
                    <span class="btn-label"><i class="ti-timer"></i></span>
                    <!-- <b>Próxima reunião:</b> {{ formatNextMonitoring(resultEvaluation.plan.next_monitoring, steps) }} -->
                    <b>Próxima reunião:</b> {{ formatNextMonitoring(getNextMonitoring(resultEvaluation.plan.monitoring_meetings), steps) }}
                  </div>
                </div>

                <div class="row" style="margin-top: 20px;">
                  <div class="col-md-12" @click="showMeetingSchedule = !showMeetingSchedule">
                    <span class="btn-label">
                      <i v-if="showMeetingSchedule" class="ti-angle-up" style="color: #007bff;"></i>
                      <i v-else class="ti-angle-down" style="color: #007bff;"></i>
                    </span>
                    <span style="color: #007bff; cursor: pointer;">Gerenciar reuniões</span>
                  </div>
                </div>

                <div v-if="showMeetingSchedule" class="row">
                  <div class="col-md-12" style="margin-bottom:13px;"><br />
                    As reuniões periódicas de acompanhamento devem ter um intervalo de no mínimo 15 dias da data de início ou da última reunião.
                  </div>
                  <div class="col-md-12">
                    <div class="form-gorup">
                      <label class="control-label">Reuniões de Acompanhameto*</label>
                      <div v-for="(meeting, index) in monitoring.all_meetings" :key="index" class="input-group" style="margin-bottom: 10px;">
                        <el-date-picker
                          v-model="monitoring.all_meetings[index].date"
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="Selecione a data"
                          :disabled="!resultEvaluation.plan.start_date || !resultEvaluation.plan.end_date || meeting.status == 1 || meeting.status == 2 || meeting.date === new Date().toISOString().split('T')[0]"
                          :picker-options="getMeetingDatePickerOptions(index, steps)">
                        </el-date-picker>
                        <span class="input-group-btn">
                          <button class="btn btn-danger btn-sm"
                                  type="button"
                                  @click="removeMeetingDate(index, steps)"
                                  :disabled="monitoring.all_meetings.length === 1 || meeting.status == 1 || meeting.status == 2 || meeting.date === new Date().toISOString().split('T')[0]">
                            <i class="fa fa-trash"></i>
                          </button>
                        </span>
                      </div>
                      <!-- Botão de adicionar nova data manual -->
                      <button class="btn btn-info btn-sm" type="button" @click="addMeetingDate(steps)" :disabled="!canAddNewMeetingDate">
                        <i class="fa fa-plus"></i> Adicionar Data
                      </button>
                      <span v-if="noMeetingDateAvailable" style="font-size: 12px; color: gray; margin-left: 10px;">Não é possível adicionar mais reuniões dentro do intervalo atual.</span>
                    </div>
                  </div>
                </div>

                <div style="margin:30px 0;">
                  <button type="button" @click="validMonitoring()" class="btn btn-wd btn-success">
                    <loading-spin :check="loading" class="loading-spin-login"></loading-spin>
                    Salvar
                  </button>
                  <button type="button" @click="handleCancelMonitoring()" class="btn btn-wd btn-danger">
                    Cancelar
                  </button>
                </div>
              </div>
              <!-- END MONITORING -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 col-sm-12" style="text-align:center;margin:20px 0;">
        <button @click="openProfile()" type="button" class="btn btn-wd btn-default btn-move-left"><span
            class="btn-label"><i class="ti-angle-left"></i></span>
          Voltar
        </button>
      </div>
    </div>

  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Select, Option, Slider} from 'element-ui'
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import PProgress from 'src/components/UIComponents/Progress.vue'
  import { checkAccessPowerUniversity } from 'src/helpers/general'
  import InfoPDI9Box from './../InfoPDI9Box.vue'
  import swal from 'sweetalert2'
  import moment from 'moment'

  export default {
    mounted () {
      this.collaboratorId = this.$route.params.collaboratorId
      this.evaluationId = this.$route.params.evaluationId
      this.getResultEvaluation()
      this.getDevelopmentPlans()
      this.getSuccessIndicators()
      this.getMonitoringFrequency()
      if (this.resultEvaluation) {
        this.originalGoals = this.resultEvaluation.plan ? this.resultEvaluation.plan.action_plan_goals.map(goal => ({
          id: goal.id,
          progress: goal.progress
        })) : []
      }
    },
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Option.name]: Option,
      [Select.name]: Select,
      [Slider.name]: Slider,
      [InfoPDI9Box.name]: InfoPDI9Box,
      StatsCard,
      ChartCard,
      CircleChartCard,
      PProgress
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      const vm = this
      return {
        collaboratorId: null,
        evaluationId: null,
        resultEvaluation: null,
        successIndicators: [],
        monitoringFrequency: [],
        developmentPlans: [],
        developmentPlanSelected: {},
        originalGoals: [],
        originalPlan: {},
        monitoringGoals: [],
        monitoring: {
          all_meetings: [{
            date: '',
            status: false
          }]
        },
        developmentPlan: {
          evaluation_id: '',
          development_plan_id: 6,
          description: '',
          action_plan_objective: '',
          identified_improvement_areas: '',
          action_plan_goals: [{
            goal: '',
            strategy: '',
            due_date: ''
          }],
          strategies_to_reach_goals: '',
          start_date: '',
          success_indicators: [],
          monitoring_frequencies: [],
          monitoring_meetings: [{
            date: '',
            status: false
          }],
          end_date: '',
          skill_id: ''
        },
        atLeastOneMeetingHeld: false,
        steps: {
          index: true,
          update: false,
          monitoring: false
        },
        loading: false,
        currentMeetingIndex: 0,
        slideDirection: 'slide-left',
        showMeetingSchedule: false,
        noMeetingDateAvailable: false,
        pickerOptionsStart: {
          // shortcuts: [{
          //   text: 'Hoje',
          //   onClick (picker) {
          //     picker.$emit('pick', new Date())
          //   }
          // }],
          disabledDate (date) {
            if ((date < new Date())) { // Desabilitar dias anteriores e data atual.
              return true
            } else {
              return false
            }
          }
        },
        pickerOptionsEnd: {
          disabledDate: (date) => {
            const today = new Date()
            const start = this.developmentPlan.start_date ? new Date(this.developmentPlan.start_date) : null
            const meetings = this.developmentPlan.monitoring_meetings || []

            // Busca a última reunião já realizada
            const lastDoneMeetingDate = meetings
              .filter(m => m.status === 1 && m.date)
              .map(m => new Date(m.date))
              .sort((a, b) => b - a)[0] // Pega a mais recente

            const d = new Date(date)

            if (d < today) return true // Não permite antes de hoje
            if (start && d <= start) return true // Não permite antes ou igual à data de início
            if (start) {
              const minEndDate = new Date(start) // Não com menos de 20 dias da data de início
              minEndDate.setDate(minEndDate.getDate() + 20)
              if (d < minEndDate) return true
            }
            if (lastDoneMeetingDate && d < lastDoneMeetingDate) return true // Não permite antes da última reunião realizada

            return false
          }
        },
        pickerOptionsGoals: {
          disabledDate: (date) => {
            const start = this.developmentPlan.start_date ? new Date(this.developmentPlan.start_date) : null
            const end = this.developmentPlan.end_date ? new Date(this.developmentPlan.end_date) : null

            if (!start || !end) return true // Desabilita tudo se não houver datas definidas

            const current = new Date(date)
            return current < start || current > end
          }
        }
      }
    },
    filters: {
      formatDateBr (date) {
        return moment(date).format('DD/MM/YYYY')
      }
    },
    computed: {
      currentUser () {
        return this.$store.getters.currentUser
      },
      pastMeetings () {
        return this.resultEvaluation.plan.monitoring_meetings.filter(m => m.status === 1 || m.status === 2).sort((a, b) => new Date(a.date) - new Date(b.date))
      },
      currentPastMeeting () {
        return this.pastMeetings[this.currentMeetingIndex]
      },
      monitoringMeetingSignatureStepUpdate () {
        // Junta todas as datas em uma única string
        return this.developmentPlan.monitoring_meetings.map(m => m.date).join('|')
      },
      monitoringMeetingSignatureStepMonitoring () {
        return this.monitoring.all_meetings.map(m => m.date).join('|')
      },
      canAddNewMeetingDate () {
        const meetings = this.steps.update ? this.developmentPlan.monitoring_meetings : this.monitoring.all_meetings

        if (!meetings || meetings.length === 0) return false

        const last = meetings[meetings.length - 1]
        return !this.noMeetingDateAvailable && !!last && !!last.date
      }
    },
    methods: {
      getResultEvaluation () {
        let url = `/collaborator/manager/collaborator/${this.collaboratorId}/result-evaluation/${this.evaluationId}`
        axios.get(url).then((res) => {
          this.resultEvaluation = res.data
          this.resultEvaluation.plan.monitoring_meetings.forEach(meeting => {
            if (meeting.status === 1) {
              this.atLeastOneMeetingHeld = true
            }
          })
        }).catch(error => {
          let message = 'Não foi possível completa requisição, tente novamente mais tarde.'

          if (error.response.status !== 500) {
            message = error.response.data.error
          }

          swal({
            title: 'Avaliação!',
            text: message,
            type: 'error',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'Voltar',
            buttonsStyling: false,
            allowOutsideClick: false,
            preConfirm: () => {
              return (new Promise((resolve, reject) => {
                resolve('OK')
              }))
            }
          }).then(() => {
            this.$router.push(`/avaliacao/equipe/perfil/${this.collaboratorId}`)
          }).catch(swal.noop)
        })
      },
      getDevelopmentPlans () {
        let url = `/collaborator/manager/development-plan-evaluation`
        axios.get(url).then((res) => {
          this.developmentPlans = res.data
        })
      },
      getSuccessIndicators () {
        let url = '/collaborator/manager/success-indicator'
        axios.get(url).then((res) => {
          this.successIndicators = res.data
        })
      },
      getMonitoringFrequency () {
        let url = '/collaborator/manager/monitoring-frequency'
        axios.get(url).then((res) => {
          this.monitoringFrequency = res.data
        })
      },
      developmentPlanShow () {
        const developmentPlan = this.developmentPlans.find(value => value.id === this.developmentPlan.development_plan_id)

        if (developmentPlan) {
          this.developmentPlanSelected = developmentPlan
        } else {
          this.developmentPlanSelected = {}
        }
      },
      checkAccessUser (developmentPlanId) {
        if (developmentPlanId === 5) {
          return checkAccessPowerUniversity(this.currentUser)
        }

        return true
      },
      parseDate (dateString) {
        const [year, month, day] = dateString.split('-').map(Number)
        return new Date(year, month - 1, day) // month é zero-based
      },
      getMonitoringByToday (monitorings) {
        const today = new Date()
        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, '0') // getMonth() retorna de 0 a 11
        const day = String(today.getDate()).padStart(2, '0')

        const formattedToday = `${year}-${month}-${day}`
        const monitoring = monitorings.find(item => {
          const itemDate = new Date(item.date).toISOString().split('T')[0]
          return itemDate === formattedToday && item.status === 0
        })
        return monitoring || false
      },
      checkMonitoringByToday (nextMonitoring) {
        if (!nextMonitoring) {
          return false
        }
        const today = new Date()
        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, '0') // getMonth() retorna de 0 a 11
        const day = String(today.getDate()).padStart(2, '0')

        const formattedToday = `${year}-${month}-${day}`

        return nextMonitoring.date === formattedToday
      },
      getNextMonitoring (monitorings) {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const futureMonitorings = monitorings
          .filter(item => {
            const itemDate = this.parseDate(item.date)
            itemDate.setHours(0, 0, 0, 0)
            return itemDate > today && item.status !== 1
          })
          .sort((a, b) => this.parseDate(a.date) - this.parseDate(b.date))
        return futureMonitorings.length ? futureMonitorings[0] : false
      },
      formatNextMonitoring (nextMonitoring, step) {
        if (!nextMonitoring) {
          return 'NÃO AGENDADA'
        }
        const today = new Date()
        today.setHours(0, 0, 0, 0)

        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, '0')
        const day = String(today.getDate()).padStart(2, '0')

        const formattedToday = `${year}-${month}-${day}`

        if (nextMonitoring.date === formattedToday) {
          if (step.index) {
            return 'HOJE'
          }
          if (step.monitoring) {
            return 'NÃO AGENDADA'
          }
        } else {
          return this.formatDate(nextMonitoring.date)
          // return nextMonitoring.date
        }
      },
      handleCancelEditing () {
        if (this.originalPlan) {
          this.developmentPlan = JSON.parse(JSON.stringify(this.originalPlan))
        }
        this.handleStep('index')
      },
      handleCancelMonitoring () {
        // Restaura os valores originais nas metas
        this.monitoringGoals = JSON.parse(JSON.stringify(this.originalGoals))
        this.handleStep('index')
      },
      handleMonitoring (plan) {
        this.monitoringGoals = JSON.parse(JSON.stringify(plan.action_plan_goals))
        this.originalGoals = JSON.parse(JSON.stringify(plan.action_plan_goals)) // 🔥 salva os originais

        const todayMonitoring = this.getMonitoringByToday(plan.monitoring_meetings)

        // Garante que todayMonitoring seja um objeto, mesmo que vazio
        const monitoringData = todayMonitoring ? JSON.parse(JSON.stringify(todayMonitoring)) : {}
        // const monitoringData = {}

        // Atualiza o objeto reativo this.monitoring sem substituí-lo
        Object.assign(this.monitoring, {
          id: monitoringData.id || null,
          date: monitoringData.date || '',
          status: monitoringData.status || false,
          feedbacks: monitoringData.feedbacks || '',
          evaluation_development_plan_id: monitoringData.evaluation_development_plan_id || null,
          goal_progresses: monitoringData.goal_progresses || [],
          created_at: monitoringData.created_at || null,
          updated_at: monitoringData.updated_at || null,
          all_meetings: JSON.parse(JSON.stringify(plan.monitoring_meetings))
        })

        this.handleStep('monitoring')
      },
      handleEdit (plan) {
        const clonedPlan = JSON.parse(JSON.stringify(plan))
        this.originalPlan = clonedPlan

        this.developmentPlan.evaluation_id = this.resultEvaluation.id
        this.developmentPlan.development_plan_id = clonedPlan.development_plan_id
        this.developmentPlan.description = clonedPlan.description
        this.developmentPlan.action_plan_objective = clonedPlan.action_plan_objective
        this.developmentPlan.identified_improvement_areas = clonedPlan.identified_improvement_areas
        this.developmentPlan.action_plan_goals = clonedPlan.action_plan_goals
        this.developmentPlan.action_plan_goals_old = clonedPlan.action_plan_goals_old
        this.developmentPlan.strategies_to_reach_goals_old = clonedPlan.strategies_to_reach_goals_old
        this.developmentPlan.start_date = clonedPlan.start_date
        this.developmentPlan.end_date = clonedPlan.end_date
        this.developmentPlan.success_indicators = clonedPlan.success_indicators
          .map(indicator => indicator.success_indicator_id)
          .filter((value, index, self) => self.indexOf(value) === index)
        clonedPlan.monitoring_frequencies.forEach((frequency) => {
          this.developmentPlan.monitoring_frequencies.push(frequency.monitoring_frequency_id)
        })
        this.developmentPlan.monitoring_meetings = clonedPlan.monitoring_meetings
        this.developmentPlan.skill_id = clonedPlan.skill_id
        this.developmentPlanShow()
        this.handleStep('update')
      },
      // hasChanges () {
      //   const goalsChanged = this.monitoringGoals.some(goal => {
      //     const original = this.originalGoals.find(g => g.id === goal.id)
      //     return original && goal.progress !== original.progress
      //   })

      //   const feedbackFilled = this.monitoring.feedbacks && this.monitoring.feedbacks.trim() !== ''

      //   return goalsChanged || feedbackFilled
      // },
      addGoal () {
        this.developmentPlan.action_plan_goals.push({goal: '', strategy: '', due_date: ''})
      },
      removeGoal (index) {
        if (this.developmentPlan.action_plan_goals.length > 1) {
          this.developmentPlan.action_plan_goals.splice(index, 1)
        }
      },
      validMonitoring () {
        if (!this.monitoring.feedbacks || this.monitoring.feedbacks.trim() === '') {
          swal({
            title: 'Atenção!',
            text: 'Por favor, preencha o campo de feedback.',
            type: 'error',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'OK',
            buttonsStyling: false,
            allowOutsideClick: false
          }).catch(swal.noop)
        } else if (this.monitoring.all_meetings.some(meeting => !meeting.date)) {
          swal({
            title: 'Atenção!',
            text: 'Por favor, preencha a data das reuniões adicionadas.',
            type: 'error',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'OK',
            buttonsStyling: false,
            allowOutsideClick: false
          }).catch(swal.noop)
        } else {
          this.registerMonitoringMeeting()
        }
      },
      registerMonitoringMeeting () {
        swal({
          title: 'Você tem certeza?',
          html: 'A reunião de acomanhamento será encerrada.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Finalizar Acompanhamento',
          buttonsStyling: false,
          preConfirm: async () => {
            const originalGoalsMap = this.originalGoals.reduce((acc, goal) => {
              acc[goal.id] = goal
              return acc
            }, {})

            const goalsWithVariation = this.monitoringGoals.map(goal => {
              const original = originalGoalsMap[goal.id] || {}
              const variation = (goal.progress != null ? goal.progress : 0) - (original.progress != null ? original.progress : 0)

              return {
                ...goal,
                progress_variation: variation
              }
            })
            const payload = {
              goals: goalsWithVariation,
              monitoring: this.monitoring
            }
            let url = '/collaborator/manager/register-monitoring-meeting'
            await axios.post(url, payload)
            .catch(error => {
              let message = 'Não foi possível completa requisição, tente novamente mais tarde.'
              if (error.response.status !== 500) {
                message = error.response.data.error
              }
              swal.showValidationError(message)
              return (new Promise((resolve, reject) => {
                reject(new Error(message))
              }))
            })
          }
        })
        .then((res) => {
          swal({
            title: 'Acompanhamento!',
            text: 'A Reunião de Acompanhamento foi registrada com sucesso!',
            type: 'success',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'OK',
            buttonsStyling: false,
            allowOutsideClick: false,
            preConfirm: () => {
              return (new Promise((resolve, reject) => {
                resolve('OK')
              }))
            }
          }).then(() => {
            this.updateDevelopmentPlanView()
          })
        }).catch(swal.noop)
      },
      validDevelopmentPlan () {
        const goals = this.developmentPlan.action_plan_goals || []
        const hasInvalidGoal = goals.some(goal => {
          return (
            !goal.goal ||
            !goal.strategy ||
            !goal.due_date
          )
        })
        if (!!this.developmentPlan.evaluation_id &&
          !!this.developmentPlan.development_plan_id &&
          // !!this.developmentPlan.description &&
          !!this.developmentPlan.action_plan_objective &&
          !!this.developmentPlan.identified_improvement_areas &&
          !!this.developmentPlan.action_plan_goals &&
          // !!this.developmentPlan.strategies_to_reach_goals &&
          !!this.developmentPlan.start_date &&
          !!this.developmentPlan.end_date &&
          // !!this.developmentPlan.skill_id &&
          this.developmentPlan.success_indicators.length !== 0 &&
          this.developmentPlan.monitoring_meetings.length > 0 &&
          this.developmentPlan.monitoring_meetings.every(meeting => !!meeting.date) &&
          // this.developmentPlan.monitoring_frequencies.length !== 0 &&
          !hasInvalidGoal
        ) {
          this.saveDevelopmentPlan()
        } else {
          swal({
            title: 'Plano de Ação!',
            text: 'Preencha todo os campos (*) obrigatórios.',
            type: 'error',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'OK',
            buttonsStyling: false,
            allowOutsideClick: false
          }).catch(swal.noop)
        }
      },
      saveDevelopmentPlan () {
        swal({
          title: 'Você tem certeza!',
          html: 'Plano de Ação será atualizado.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Atualizar Plano de Ação',
          buttonsStyling: false,
          preConfirm: async () => {
            let url = '/collaborator/manager/collaborator-evaluation-plan'
            await axios.put(url, this.developmentPlan)
            .catch(error => {
              let message = 'Não foi possível completa requisição, tente novamente mais tarde.'
              if (error.response.status !== 500) {
                message = error.response.data.error
              }
              swal.showValidationError(message)
              return (new Promise((resolve, reject) => {
                reject(new Error(message))
              }))
            })
          }
        })
        .then((res) => {
          swal({
            title: 'Plano de Ação!',
            text: 'Plano de Ação foi atualizado com sucesso.',
            type: 'success',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'OK',
            buttonsStyling: false,
            allowOutsideClick: false,
            preConfirm: () => {
              return (new Promise((resolve, reject) => {
                resolve('OK')
              }))
            }
          }).then(() => {
            this.updateDevelopmentPlanView()
          })
        }).catch(swal.noop)
      },
      updateDevelopmentPlanView () {
        this.getResultEvaluation()
        this.handleStep('index')
      },
      openProfile () {
        this.$router.push(`/avaliacao/equipe/perfil/${this.collaboratorId}`)
      },
      percentColor (percent) {
        let classColor = 'success'

        if (percent >= 0 && percent < 40) {
          classColor = 'danger'
        } else if (percent >= 40 && percent < 80) {
          classColor = 'warning'
        }
        return classColor
      },
      percentTotalColor (percent) {
        let color = 'green'

        if (percent >= 0 && percent < 40) {
          color = 'red'
        }

        if (percent >= 40 && percent < 80) {
          color = 'orange'
        }

        return color
      },
      handleStep (step) {
        switch (step) {
          case 'index':
            this.steps.index = true
            this.steps.update = false
            this.steps.monitoring = false
            break
          case 'update':
            this.steps.index = false
            this.steps.update = true
            this.steps.monitoring = false
            break
          case 'monitoring':
            this.steps.index = false
            this.steps.update = false
            this.steps.monitoring = true
            break
        }
      },
      translateStatus (status) {
        const translations = {
          pending: 'Pendente',
          in_progress: 'Em Andamento',
          at_risk: 'Em Risco',
          completed: 'Concluído',
          overdue: 'Atrasado'
        }
        return translations[status] || status
      },
      formatDate (dateStr) {
        if (!dateStr) return ''

        // Extrair apenas a parte da data (YYYY-MM-DD)
        const [datePart] = dateStr.split(' ')
        const [year, month, day] = datePart.split('-').map(Number)

        // Criar a data corretamente no fuso local
        const date = new Date(year, month - 1, day)

        return date.toLocaleDateString('pt-BR')
      },
      formatTooltip (val) {
        return `${val}%`
      },
      addMeetingDate (step) {
        const meetings = step.update ? this.developmentPlan.monitoring_meetings : this.monitoring.all_meetings

        if (!this.canAddNewMeetingDate) return

        meetings.push({ date: '', status: false })
        this.$nextTick(() => {
          this.updateMeetingAvailability(step)
        })
      },
      removeMeetingDate (index, step) {
        const meetings = step.update ? this.developmentPlan.monitoring_meetings : this.monitoring.all_meetings

        if (meetings.length > 1) {
          meetings.splice(index, 1)
          this.$nextTick(() => {
            this.updateMeetingAvailability(step)
          })
        }
      },
      getMeetingDatePickerOptions (index, step) {
        return {
          disabledDate: (date) => {
            let start
            let end
            if (step.update) {
              start = this.developmentPlan.start_date ? new Date(this.developmentPlan.start_date) : null
              end = this.developmentPlan.end_date ? new Date(this.developmentPlan.end_date) : null
            }
            if (step.monitoring) {
              start = this.resultEvaluation.plan.start_date ? new Date(this.resultEvaluation.plan.start_date) : null
              end = this.resultEvaluation.plan.end_date ? new Date(this.resultEvaluation.plan.end_date) : null
            }

            if (!start || !end) return true // Desabilita tudo se não tiver início e fim

            // Define a data mínima permitida
            let minDate = new Date(start)
            if (index > 0) {
              let prevMeeting
              if (step.update) {
                prevMeeting = this.developmentPlan.monitoring_meetings[index - 1]
              }
              if (step.monitoring) {
                prevMeeting = this.monitoring.all_meetings[index - 1]
              }
              const prevMeetingDate = prevMeeting ? prevMeeting.date : null

              if (prevMeetingDate) {
                minDate = new Date(prevMeetingDate)
              }
            }
            minDate.setDate(minDate.getDate() + 15) // Precisa ter 15 dias de diferença

            const currentDate = new Date(date)

            return currentDate < minDate || currentDate > end
          }
        }
      },
      prevMeeting () {
        if (this.currentMeetingIndex > 0) {
          this.slideDirection = 'slide-right' // voltando: entra da esquerda
          this.currentMeetingIndex--
        }
      },
      nextMeeting () {
        if (this.currentMeetingIndex < this.pastMeetings.length - 1) {
          this.slideDirection = 'slide-left' // indo para frente: entra da direita
          this.currentMeetingIndex++
        }
      },
      goToMeeting (index) {
        if (index !== this.currentMeetingIndex) {
          this.slideDirection = index > this.currentMeetingIndex ? 'slide-left' : 'slide-right'
          this.currentMeetingIndex = index
        }
      },
      updateMeetingAvailability (step) {
        const start = step.update ? this.developmentPlan.start_date : this.resultEvaluation.plan.start_date
        const end = step.update ? this.developmentPlan.end_date : this.resultEvaluation.plan.end_date

        const meetings = step.update ? this.developmentPlan.monitoring_meetings : this.monitoring.all_meetings

        if (!start || !end) {
          this.noMeetingDateAvailable = true
          return
        }

        const filledMeetings = meetings.filter(m => !!m.date && m.status !== 1)
        let baseDate = filledMeetings.length > 0 ? new Date(filledMeetings[filledMeetings.length - 1].date) : new Date(start)
        baseDate.setDate(baseDate.getDate() + 15)

        // Verifica se ainda existe data válida
        if (baseDate >= new Date(end)) {
          // Desabilita botão
          this.noMeetingDateAvailable = true

          // Remove inputs vazios
          const remaining = meetings.filter(m => !!m.date || m.status === 1)
          if (remaining.length === 0) {
            remaining.push({ date: '', status: false })
          }

          if (step.update) {
            this.developmentPlan.monitoring_meetings = remaining
          } else {
            this.monitoring.all_meetings = remaining
          }
        } else {
          this.noMeetingDateAvailable = false
        }
      },
      clearAllDates (value) {
        if (!value) {
          this.developmentPlan.end_date = ''
          this.developmentPlan.action_plan_goals.forEach(goal => {
            goal.due_date = ''
          })
          this.developmentPlan.monitoring_meetings.forEach(meeting => {
            if (meeting.status !== 1) {
              meeting.date = ''
            }
          })
          const nonEmpty = this.developmentPlan.monitoring_meetings.filter(meeting => !!meeting.date || meeting.status === 1)

          this.developmentPlan.monitoring_meetings = nonEmpty.length > 0 ? nonEmpty : [{ date: '', status: 0 }]

          this.updateMeetingAvailability(this.steps)
        }
      }
    },
    watch: {
      'developmentPlan.end_date' (newDate) {
        if (!newDate) return

        const endDate = new Date(newDate)

        this.developmentPlan.monitoring_meetings.forEach(meeting => {
          if (meeting.status !== 1 && meeting.date) {
            const meetingDate = new Date(meeting.date)

            if (meetingDate > endDate) {
              // Zera a data da reunião que ficou fora do intervalo
              meeting.date = null
            }
          }
        })

        this.$nextTick(() => {
          this.updateMeetingAvailability(this.steps)
        })
      },
      'developmentPlan.start_date' () {
        this.$nextTick(() => {
          this.updateMeetingAvailability(this.steps)
        })
      },
      monitoringMeetingSignatureStepUpdate () {
        if (this.steps.update) {
          this.updateMeetingAvailability(this.steps)
        }
      },
      monitoringMeetingSignatureStepMonitoring () {
        if (this.steps.monitoring) {
          this.updateMeetingAvailability(this.steps)
        }
      }
    }
  }

</script>

<style scoped>
.slide-left-enter-active, .slide-left-leave-active,
.slide-right-enter-active, .slide-right-leave-active {
  transition: all 0.4s ease;
}

.slide-left-enter {
  transform: translateX(100%);
  opacity: 0;
}
.slide-left-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-right-enter {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.carousel-wrapper {
  position: relative;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 50px; /* espaço lateral pros botões */
}

.carousel-card {
  padding: 15px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  box-sizing: border-box;
  background-color: white;

  max-height: 300px;
  overflow-y: auto;
  width: 100%; /* ocupa o espaço entre os botões */
}

.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border: 1px solid #dcdfe6;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 16px;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-button.left {
  left: 10px;
}

.nav-button.right {
  right: 10px;
}

.nav-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

.nav-button:disabled:hover {
  background: inherit;
  color: inherit;
}

.carousel-indicators {
  /* position: absolute; */
  bottom: -30px; /* pode ajustar esse valor conforme necessário */
  display: flex;
  justify-content: center;
  gap: 8px;
}

.indicator-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ccc;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.indicator-dot.active {
  background-color: #409EFF;
}
</style>

<style>
.grade_comp {
  text-align:right;
}

h5.card-title {
  margin-bottom:0 !important;
}

.chart-circle {
  margin-top: 3px !important;
  margin-bottom: 17px !important;
}

.non-bold-label {
  font-weight: normal;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.goal {
  border-left: 2px solid #a4b1c1;
  border-radius: 5px;
  padding-left: 5px;
  padding-right: 5px;
}

.goal-title {
  /* background-color: #f5f5f5; */
  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  display: flex;
  gap: 10px;
}

.goal-body {
  /* background-color: #f5f5f5; */
  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Manager/Evaluation/Team/Overview.vue